import * as PIXI from 'pixi.js'

const whitelist = [
  'transform',
  'position',
  'scale',
  'rotation',
  'pivot',
  'skew',
  'anchor'
]

const blacklist = [
  'children',
  'parent',
  'tempDisplayObjectParent',
  'scope',

  // Not needed
  'delayLimit',
  'lastTime',
]

const typeBlacklist = [
  'object',
  'array',
]

const propDepth = 3
class MismatchConstructor {}

function getTargetObj(props, latestObj) {
  let arr = props
  let obj = latestObj
  if (typeof props === 'string') {
    arr = props.split('.')
  }

  while (arr.length > 1) {
    const newProp = arr.shift()
    obj = obj[newProp]
  }

  return { obj, lastProp: arr.shift() }
}

export default class ActiveSpine extends React.Component {
  constructor() {
    super()

    this.TransformBaseRef =
      typeof PIXI.TransformBase === 'function'
        ? PIXI.TransformBase
        : MismatchConstructor;
    this.ObservablePointRef =
      typeof PIXI.ObservablePoint === 'function'
        ? PIXI.ObservablePoint
        : MismatchConstructor;
  }

  state = {}

  onKeyDown = (e, prop, isNumber) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.setPropertyValue(prop.path, e.target.value)
    } else if (!isNumber) {
      return
    }

    let value = parseFloat(e.target.value, 10)
    let update = false
    let size = 1
    if (e.altKey) {
      size = 0.1
    } else if (e.shiftKey) {
      size = 10
    }

    switch (e.key) {
      case 'ArrowUp':
        update = !Number.isNaN(value)
        value += size
        break
      case 'ArrowDown':
        update = !Number.isNaN(value)
        value -= size
        break
      default:
        break
    }

    if (update) {
      e.target.value = value
      this.setPropertyValue(prop.path, value)
    }
  }

  setPropertyValue = (prop, value) => {
    const { spine } = this.props
    const isNumber = parseFloat(value, 10)
    const isNullOrNaN =
      typeof value === 'string'
        ? value.match(/^(\\null|\\NaN|\\undefined)$/)
        : false

    let newValue

    if (!Number.isNaN(isNumber)) {
      newValue = isNumber
    } else if (isNullOrNaN) {
      // is null or NaN or undefined sent not like string
      switch (value) {
        case '\\null': {
          newValue = null
          break
        }
        case '\\NaN': {
          newValue = NaN
          break
        }
        case '\\undefined': {
          newValue = undefined
          break
        }
        default:
          break
      }
    } else {
      // String
      newValue = value
    }

    const { obj, lastProp } = getTargetObj(prop, spine)
    obj[lastProp] = newValue
  }

  getAllProperties = () => {
    const { spine } = this.props
    const properties = []
    for (const property in spine) {
      if (property[0] === '_' || blacklist.indexOf(property) !== -1) {
        continue
      }
      properties.push(...this.serialize(spine[property], [ property ], propDepth))
    }
    properties.sort((a, b) => (a.path > b.path ? 1 : -1))

    return properties
  }

  serialize(value, path, depth) {
    depth -= 1
    if (depth < 0) {
      return []
    }
    const type = typeof value
    if (type === 'undefined' || type === 'function') {
      return []
    } else if (
      type === 'string' ||
      type === 'number' ||
      type === 'boolean' ||
      value === null
    ) {
      return [ { path: path.join('.'), type, value } ]
    } else if (type === 'object') {
      if (value === null) {
        return [ { path: path.join('.'), type, value } ]
      }
      if (Array.isArray(value)) {
        return [ { path: path.join('.'), type: 'Array' } ]
      }
      if (whitelist.indexOf(path[path.length - 1]) !== -1) {
        const properties = []
        for (const property in value) {
          if (blacklist.indexOf(property) !== -1) {
            continue
          }
          if (property[0] === '_') {
            continue
          }
          properties.push(
            ...this.serialize(value[property], [...path, property], depth)
          )
        }
        if (value instanceof this.ObservablePointRef) {
          properties.push(
            {
              path: `${path.join('.')}.x`,
              type: 'number',
              value: value.x
            },
            {
              path: `${path.join('.')}.y`,
              type: 'number',
              value: value.y
            }
          )
        }
        if (value instanceof this.TransformBaseRef) {
          properties.push({
            path: `${path.join('.')}.rotation`,
            type: 'number',
            value: value.rotation
          });
        }
        if (properties.length !== 0) {
          return properties
        }
      }
      return [ { path: path.join('.'), type: 'Object' } ]
    }
    return [
      {
        path: path.join('.'),
        type:
          typeof value.constructor !== 'undefined'
            ? value.constructor.name || type
            : type
      }
    ]
  }

  stopAnimations = () => {
    const { spine } = this.props
    spine.state.clearTrack(0)
    spine.skeleton.setToSetupPose()
  }

  playAnimation = (anim, loop) => {
    const { spine } = this.props
    spine.state.setAnimation(0, anim, loop)
  }

  queueAnimation = (animation) => {
    const { spine } = this.props
    const currentTrack = spine.state.getCurrent(0)
    const isComplete = currentTrack && currentTrack.isComplete()
    const isLooping = currentTrack && currentTrack.loop
 
    if (!isComplete && !isLooping) {
      spine.state.addAnimation(0, animation, false, 0)
    } else {
      spine.state.setAnimation(0, animation, false)
    }
  }

  createField = (prop) => {
    const { spine } = this.props
    const { obj, lastProp } = getTargetObj(prop.path, spine)
    const isNumber = !Number.isNaN(obj[lastProp])
    return (
      <input
        type="text"
        data-isNumber={isNumber}
        defaultValue={obj[lastProp]}
        onKeyDown={(e) => { this.onKeyDown(e, prop, isNumber) }}
        onBlur={(e) => {
          this.setPropertyValue(prop.path, e.target.value)
        }}
        readOnly={!isNumber && typeof pathTarget === 'string'}
      />
    )
  }

  createCheckbox = (prop) => {
    const { spine } = this.props
    const { obj, lastProp } = getTargetObj(prop.path, spine)
    return (
      <input
        type="checkbox"
        defaultChecked={obj[lastProp]}
        onChange={(e) => { obj[lastProp] = e.target.checked }}
      />
    )
  }

  render() {
    const { spine } = this.props
    const spineProps = this.getAllProperties(spine, [])

    return (
      <div className="activeSpine">
        { spineProps.map(prop => {
          const { obj, lastProp } = getTargetObj(prop.path, spine)
          return typeBlacklist.indexOf(prop.type.toLowerCase()) > -1 ? null : (
            <div className="property" key={prop.path}>
              <p>{`${prop.path}`}</p>
              { typeof obj[lastProp] === 'boolean'
                ? this.createCheckbox(prop)
                : this.createField(prop)
              }
            </div>
          )
        })}
        <div className="animations">
          <div className="title">ANIMATIONS:</div>
          <div className="list" style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <input id="stop" type="button" value="Stop animations" onClick={() => { this.stopAnimations() }} />
              { spine && spine.spineData && spine.spineData.animations.map(anim => (
                <div key={anim.name}>
                  <p>{`${anim.name}`}</p>
                  <input type="button" value="Play once" onClick={() => { this.playAnimation(anim.name, false) }} />
                  <input type="button" value="Loop" onClick={() => { this.playAnimation(anim.name, true) }} />
                  <input type="button" value="Queue" onClick={() => { this.queueAnimation(anim.name) }} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}